import { useEffect, useState } from "react";
import { FileDown, MessageCircle, CalendarDays } from "lucide-react";
import { api, fileUrl, waLink, fmtDate } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { CatalogAccess } from "@/components/site/CatalogAccess";

export default function Catalogo() {
  const { settings } = useApp();
  const [cat, setCat] = useState(null);
  const [fallback, setFallback] = useState("");
  useEffect(() => {
    api.get("/catalog").then((r) => setCat(r.data));
    api.get("/media", { params: { category: "animales" } }).then((r) => setFallback(r.data.find((m) => m.type === "image")?.url || ""));
  }, []);
  const cover = fileUrl(cat?.cover_url || fallback);

  return (
    <div data-testid="catalogo-page" className="overflow-x-hidden bg-[#F8F5EE] pt-28 sm:pt-32 pb-24">
      <section className="container-fv grid gap-14 lg:grid-cols-12 items-center">
        <div className="lg:col-span-5 rise">
          <div className="relative mx-auto max-w-sm lg:max-w-none">
            <div className="absolute -inset-3 translate-x-4 translate-y-4 border border-[#C5A059]" />
            <div className="relative aspect-[3/4] overflow-hidden bg-[#1D3324] shadow-2xl" data-testid="catalogo-cover">
              {cover && <img src={cover} alt="Portada del catálogo" className="h-full w-full object-cover" />}
              {!cat?.cover_url && (
                <div className="absolute inset-0 flex flex-col justify-between bg-gradient-to-b from-[#142419]/70 via-transparent to-[#142419]/90 p-8 text-stone-100">
                  <span className="f-display text-[#C5A059] italic text-xl">F&amp;V</span>
                  <div>
                    <p className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">Hacienda Fernández &amp; Vargas</p>
                    <p className="f-display text-3xl mt-2 leading-tight">Catálogo de Genética Brangus</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="lg:col-span-7">
          <p className="eyebrow rise d1">Catálogo vigente</p>
          <h1 data-testid="catalogo-title" className="f-display mt-4 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] rise d2">{cat?.title || "Catálogo de Genética"}</h1>
          <div className="gold-rule mt-6 w-32" />
          <p data-testid="catalogo-description" className="mt-6 max-w-xl text-[#5C635E] leading-relaxed whitespace-pre-line rise d3">{cat?.description}</p>
          {cat?.updated_at && (
            <p className="mt-5 flex items-center gap-2 text-sm text-[#1D3324]" data-testid="catalogo-updated-at"><CalendarDays size={16} />Actualizado el {fmtDate(cat.updated_at)}</p>
          )}
          <div className="mt-10 flex flex-wrap gap-3 rise d4">
            {cat?.pdf_url ? (
              <CatalogAccess pdfUrl={cat.pdf_url} />
            ) : (
              <span data-testid="catalogo-download-pdf-button" aria-disabled="true" className="btn-fv bg-stone-300 text-stone-600 cursor-not-allowed"><FileDown size={18} />Catálogo disponible próximamente</span>
            )}
            <a href={waLink(settings.whatsapp, `Hola, quisiera consultar sobre el ${cat?.title || "catálogo de genética"} de Hacienda Fernández & Vargas.`)}
              target="_blank" rel="noreferrer" data-testid="catalogo-whatsapp-button" className="btn-fv btn-wa"><MessageCircle size={18} />Consultar por WhatsApp</a>
          </div>
        </div>
      </section>
    </div>
  );
}
